import { render } from "./SelectTokenModal.vue?vue&type=template&id=59a02a63&scoped=true&ts=true"
import script from "./SelectTokenModal.vue?vue&type=script&lang=ts"
export * from "./SelectTokenModal.vue?vue&type=script&lang=ts"

import "./SelectTokenModal.vue?vue&type=style&index=0&id=59a02a63&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a02a63"]])

export default __exports__